import Api from '../../shared/Api';
import {
    CreateFeatureFlagInput,
    FeatureFlag,
    FeatureFlagOptions,
    UpdateFeatureFlagInput
} from './types';

const baseUrl = '/views/feature-flags';

const FeatureFlagsApi = {
    list(): Promise<FeatureFlag[]> {
        return new Api().get(baseUrl);
    },

    options(): Promise<FeatureFlagOptions> {
        return new Api().get(`${baseUrl}/options`);
    },

    create(input: CreateFeatureFlagInput): Promise<FeatureFlag> {
        return new Api().post(baseUrl, input);
    },

    update(key: string, input: UpdateFeatureFlagInput): Promise<FeatureFlag> {
        return new Api().put(`${baseUrl}/${encodeURIComponent(key)}`, input);
    },

    delete(key: string): Promise<void> {
        return new Api().delete(`${baseUrl}/${encodeURIComponent(key)}`);
    }
};

export default FeatureFlagsApi;
